/* RING KONG announcement mode — injects switch + white logo + effects, plays audio, auto-reverts on end */
(function () {
  var AUDIO_URL = "https://cdn.shopify.com/s/files/1/0925/1880/9967/files/ring-kong-announcement.mp3?v=1780119865";
  var LOGO_URL  = "https://cdn.shopify.com/s/files/1/0925/1880/9967/files/ring-kong-logo-white.svg?v=1780119864";

  var SWITCH_INNER =
    '<span class="announcement-switch__track"><span class="announcement-switch__thumb">' +
    '<svg class="announcement-switch__ico announcement-switch__ico--off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="3 9 7 9 12 4 12 20 7 15 3 15"></polygon><line x1="16" y1="9" x2="22" y2="15"></line><line x1="22" y1="9" x2="16" y2="15"></line></svg>' +
    '<svg class="announcement-switch__ico announcement-switch__ico--on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="3 9 7 9 12 4 12 20 7 15 3 15"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>' +
    '</span></span>';

  var body = document.body, audio = null, active = false, FALLBACK = 8000;

  function makeSwitch(mode) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'announcement-switch announcement-switch--' + mode;
    b.setAttribute('role', 'switch');
    b.setAttribute('aria-checked', 'false');
    b.setAttribute('aria-label', 'Ring Kong announcement');
    b.setAttribute('data-announcement-toggle', '');
    if (mode === 'mobile') b.setAttribute('data-announcement-mobile', '');
    b.innerHTML = SWITCH_INNER;
    return b;
  }

  function injectDesktop() {
    document.querySelectorAll('header.header').forEach(function (h) {
      if (h.querySelector('.announcement-switch--desktop')) return;
      h.insertBefore(makeSwitch('desktop'), h.firstChild);
    });
  }
  function injectMobile() {
    var hdr = document.querySelector('#MenuDrawer .menu-drawer__header');
    if (!hdr || !hdr.parentNode) return;
    if (hdr.parentNode.querySelector('.announcement-switch--mobile')) return;
    hdr.parentNode.insertBefore(makeSwitch('mobile'), hdr.nextSibling);
  }
  function injectLogo() {
    document.querySelectorAll('.header__logo a').forEach(function (a) {
      if (a.querySelector('.header__logo--announcement')) return;
      var img = document.createElement('img');
      img.className = 'logo header__logo--announcement';
      img.src = LOGO_URL;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      a.appendChild(img);
    });
  }
  function injectStage() {
    if (document.querySelector('[data-announcement-stage]')) return;
    var s = document.createElement('div');
    s.className = 'announcement-stage';
    s.setAttribute('data-announcement-stage', '');
    s.setAttribute('aria-hidden', 'true');
    s.hidden = true;
    s.innerHTML = '<div class="announcement-disco"></div><div class="announcement-lights"><span class="announcement-light announcement-light--1"></span><span class="announcement-light announcement-light--2"></span><span class="announcement-light announcement-light--3"></span><span class="announcement-light announcement-light--4"></span></div><span class="announcement-smoke announcement-smoke--left"></span><span class="announcement-smoke announcement-smoke--right"></span>';
    body.appendChild(s);
  }

  function stage() { return document.querySelector('[data-announcement-stage]'); }
  function setChecked(on) {
    active = on;
    document.querySelectorAll('[data-announcement-toggle]').forEach(function (b) {
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function stop() {
    if (!active) return;
    setChecked(false);
    body.classList.remove('announcement-mode');
    var s = stage(); if (s) s.hidden = true;
    if (audio) { audio.pause(); audio.currentTime = 0; audio = null; }
  }
  function start() {
    if (active) return;
    setChecked(true);
    body.classList.add('announcement-mode');
    var s = stage();
    if (s) { s.hidden = false; }
    audio = new Audio(AUDIO_URL);
    audio.addEventListener('ended', stop, { once: true });
    var p = audio.play();
    if (p && p.catch) p.catch(function () { setTimeout(stop, FALLBACK); });
  }
  function closeDrawer() {
    var d = document.getElementById('MenuDrawer'); if (!d) return;
    var btn = d.querySelector('.drawer__close, [aria-controls="MenuDrawer"]');
    if (btn) btn.click();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-announcement-toggle]');
    if (!t) return;
    e.preventDefault();
    if (active) { stop(); return; }
    if (t.hasAttribute('data-announcement-mobile')) { closeDrawer(); setTimeout(start, 280); }
    else { start(); }
  });

  function init() { injectStage(); injectDesktop(); injectMobile(); injectLogo(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-inject the mobile switch whenever the drawer opens (it may render lazily)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[aria-controls="MenuDrawer"]');
    if (opener) setTimeout(injectMobile, 50);
  });
})();
